import React, { useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import CustomModal from './CustomModal';
import UtilController from '../../controller/UtilController';
import { CurrentStoreContext } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { useToast } from '../../controller/ToastController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  setCheckAdult: (checkAdult: number) => void;
};

const CheckAlcoholModal = ({ isVisible, setVisible, setCheckAdult }: Props) => {
  const showToast = useToast();
  const [imgUrl, setImgUrl] = useState<string>('');
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const onCloseModal = () => {
    setVisible(false);
  };

  // onChange
  const onChange_imgUrl = (event: any) => {
    setImgUrl(event.target.value);
  };
  const deleteImg = () => {
    setImgUrl('');
  };
  const submitImg = () => {
    if (imgUrl !== '') {
      setCheckAdult(1);
      setVisible(false);
    }
  };

  // 이미지 등록
  const uploadImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.productUploadImg(formData, currentStore.value);
          console.log('uploadImg', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              setImgUrl(origin.name);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    }
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="checkAdultModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
            alt="close"
          />
          <div className="modal_header">
            <div className="headerBar" />
            <h2>주류 등록 시 꼭 확인해 주세요!</h2>
          </div>
          <div className="modal_title">
            <h5>
              • 가게는 주류 판매 시 식품위생법에 따른 일반음식점영업 신고와 주세법에 따른 주류판매업
              또는 의제주류판매업면허를 취득해야 합니다.
            </h5>
            <h5>
              • 이를 위반하는 경우 관련 법률에 따라 처벌을 받을 수 있으며 노크노크는 책임지지
              않습니다.
            </h5>
            <h5>
              • 주류 메뉴만 단독으로 판매할 수 없습니다. 다른 음식과 함께 판매해야 하며, 음식을
              포함한 총 주문금액의 50%를 넘길 수 없습니다.
            </h5>
          </div>
          <div className="modal_content">
            <div className="inputText">
              <div className="title">
                <h4>사업자등록증 이미지를 등록해주세요</h4>
              </div>
              <div className="row gap">
                <div className="imageInput">
                  {imgUrl === '' ? 'jpg, png형식의 이미지만 등록 가능합니다' : imgUrl}
                </div>
                <label className="addButton">
                  <input
                    type="file"
                    name="photo"
                    accept="image/*"
                    onChange={uploadImage}
                    autoFocus={false}
                  />
                  열기
                </label>
                <button className="addButton delete" onClick={deleteImg}>
                  삭제
                </button>
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button className={`submitButton ${imgUrl === '' && 'inactive'}`} onClick={submitImg}>
              주류 판매 권한 신청
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CheckAlcoholModal;

const Style = styled.div`
  .modal {
    height: 70vh;
    padding: 4% 8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .headerBar {
    width: 40px;
    height: 5px;
    background: #4dd2ae;
    border-radius: 10px;
  }
  .modal_header {
    padding-top: 2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: pre-line;
    h2 {
      font-size: 22px;
      line-height: 32px;
      color: #555555;
      font-weight: 500;
      padding-top: 30px;
    }
  }
  .modal_title {
    padding: 0 2% 6% 2%;
    h5 {
      width: 100%;
      font-size: 16px;
      line-height: 28px;
      color: #555555;
      font-weight: 500;
      padding-top: 4%;
      text-align: left;
    }
  }
  .modal_footer {
    padding-bottom: 4%;
  }

  .inputText {
    background: #f7f7f7;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    img {
      cursor: pointer;
    }

    .title {
      padding: 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .row.gap {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .imageInput {
    width: 100%;
    padding: 4px 18px;
    border: 1px solid #cecece;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
    color: #cecece;
    text-align: left;
    background: #ffffff;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .addButton {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #555555;
    padding: 4px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    white-space: nowrap;
    cursor: pointer;
  }
  .addButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  .submitButton {
    padding: 8px 12px;
  }

  input[type='file'] {
    display: none;
  }

  @media (max-width: 900px) {
    .modal {
      padding: 4%;
    }
    .modal_footer {
      padding-bottom: 8%;
    }
  }
`;
